// extracted by mini-css-extract-plugin
module.exports = {"navi":"PostNavigation_navi__3ljwk"};